module.exports = __webpack_public_path__ + "assets/img/Logitech-PW-Australia-1-Landing-Page.648346a6.jpg";